import React from "react";
import PropTypes from "prop-types";

import FinancialRow from "./FinancialRow";

const TitleRow = ({
  displayName,
  classes,
  financialDataFieldName = undefined,
  financialData = undefined,
  underlined = true,
}) => (
  <FinancialRow
    displayName={displayName}
    financialDataFieldName={financialDataFieldName}
    financialData={financialData}
    classes={classes}
    insertDivider={false}
    bold
    underlined={underlined}
    isNegative={false}
    hasLeftMargin={false}
    hasVerticalSpacing
  />
);

TitleRow.propTypes = {
  displayName: PropTypes.string.isRequired,
  financialDataFieldName: PropTypes.string,
  financialData: PropTypes.shape({
    years: PropTypes.arrayOf(
      PropTypes.shape({
        year: PropTypes.number.isRequired,
      })
    ),
    cumulative: PropTypes.objectOf(PropTypes.number),
  }),
  // eslint-disable-next-line react/forbid-prop-types -- See financialTableStyles
  classes: PropTypes.object.isRequired,
  underlined: PropTypes.bool,
};

TitleRow.defaultProps = {
  financialDataFieldName: undefined,
  financialData: undefined,
  underlined: true,
};

export default TitleRow;
